import React from 'react'

interface ProfileDropdownTipProps {
  color?: string
}

export const ProfileDropdownTip = ({
  color = 'var(--color-main-lightest)',
}: ProfileDropdownTipProps) => {
  return (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1361 7.9745C11.2239 5.70067 14.4609 5.70067 15.5487 7.97451L19.6057 16.4554C20.5583 18.4466 19.1068 20.75 16.8995 20.75H8.78537C6.57804 20.75 5.12653 18.4466 6.07908 16.4554L10.1361 7.9745Z"
        fill="var(--color-grayScale-white)"
        stroke={color}
        strokeWidth="2"
      />
      <rect
        x="1"
        y="14"
        width="29"
        height="8"
        fill="var(--color-grayScale-white)"
      />
    </svg>
  )
}
